export default "__VITE_ASSET__BwR00ZQg__"